import { arquivos, integracoes, metas, regras, relatorios, vendas, vendedores } from '../config/permissions';

const iconeNaoTemPermissao = 'fas fa-ban';

const permissaoArquivos = Utils.getPermission(arquivos.arquivos.status, arquivos.arquivos.upload);
const permissaoVendas = Utils.getPermission(vendas.vendas);
const permissaoVendedores = Utils.getPermission(vendedores.vendedores);
const permissaoRelatorios = Utils.getPermission(relatorios.relatorios);
const permissaoMetas = Utils.getPermission(metas.metas.exportar, metas.metas.importar, metas.metas.configurar, metas.metas.estagio);
const permissaoIntegracoes = Utils.getPermission(integracoes.integracoes.configuradas, integracoes.integracoes.consultas, integracoes.integracoes.marketplace);
const permissaoRegras = Utils.getPermission(regras.regras);

const menuConfig = [
  {
    title: 'Dashboard',
    key: 'home',
    icon: 'icon-monitor',
    href: { name: 'home' },
    permissao: true
  },
  {
    key: 'arquivos',
    title: 'Arquivos',
    icon: permissaoArquivos ? 'h-icon-task' : iconeNaoTemPermissao,
    permissao: permissaoArquivos,
    children: [{
      key: 'arquivos-status',
      title: 'Status',
      href: '#/arquivos',
      icon: Utils.getPermission(arquivos.arquivos.status) ? '' : iconeNaoTemPermissao,
      permissao: Utils.getPermission(arquivos.arquivos.status)
    }, {
      key: 'arquivos-upload',
      title: 'Upload',
      href: '#/arquivos/upload',
      icon: Utils.getPermission(arquivos.arquivos.upload) ? '' : iconeNaoTemPermissao,
      permissao: Utils.getPermission(arquivos.arquivos.upload)
    }]
  },
  {
    key: 'vendas',
    title: 'Vendas',
    icon: permissaoVendas ? 'h-icon-calendar' : iconeNaoTemPermissao,
    href: { name: 'vendas' },
    permissao: permissaoVendas
  },
  {
    key: 'relatorios',
    title: 'Relatórios',
    icon: permissaoRelatorios ? 'far fa-file-alt' : iconeNaoTemPermissao,
    href: { name: 'relatorios' },
    permissao: permissaoRelatorios
  },
  {
    key: 'vendedores',
    title: 'Vendedores',
    icon: permissaoVendedores ? 'h-icon-users' : iconeNaoTemPermissao,
    href: { name: 'vendedores' },
    permissao: permissaoVendedores
  },
  {
    key: 'revendedores',
    title: 'Revendedores',
    icon: permissaoVendedores ? 'fa fa-users' : iconeNaoTemPermissao,
    href: { name: 'revendedores' },
    permissao: permissaoRegras // mudar
  },
  {
    key: 'metas',
    title: 'Metas',
    icon: permissaoMetas ? 'h-icon-menu' : iconeNaoTemPermissao,
    permissao: permissaoMetas,
    children: [
      {
        title: 'Configurar',
        key: 'metas-configurar',
        href: '#/metas/configurar',
        icon: Utils.getPermission(metas.metas.configurar) ? '' : iconeNaoTemPermissao,
        permissao: Utils.getPermission(metas.metas.configurar)
      },
      {
        title: 'Exportar Modelo',
        key: 'metas-exportar-modelo',
        href: '#/metas/exportar-modelo',
        icon: Utils.getPermission(metas.metas.exportar) ? '' : iconeNaoTemPermissao,
        permissao: Utils.getPermission(metas.metas.exportar)
      },
      {
        title: 'Importar Modelo',
        key: 'metas-importar-modelo',
        href: '#/metas/importar-modelo',
        icon: Utils.getPermission(metas.metas.importar) ? '' : iconeNaoTemPermissao,
        permissao: Utils.getPermission(metas.metas.importar)
      },
      {
        title: 'Estágio Configuração',
        key: 'metas-estagio-configuracao',
        href: '#/metas/estagio-configuracao',
        icon: Utils.getPermission(metas.metas.estagio) ? '' : iconeNaoTemPermissao,
        permissao: Utils.getPermission(metas.metas.estagio)

      }
    ]
  },
  {
    key: 'Gerenciar',
    title: 'Gerenciar',
    icon: 'h-icon-setting',
    href: { name: 'regras' },
    children: [
      {
        key: 'integracoes',
        title: 'Integrações',
        permissao: permissaoIntegracoes,
        children: [
          {
            title: 'Marketplace',
            key: 'integracoes-marketplace',
            href: '#/integracoes',
            icon: Utils.getPermission(integracoes.integracoes.marketplace) ? '' : iconeNaoTemPermissao,
            permissao: Utils.getPermission(integracoes.integracoes.marketplace)
          }, {
            title: 'Configuradas',
            key: 'integracoes-configuradas',
            href: '#/integracoes/configuradas',
            icon: Utils.getPermission(integracoes.integracoes.configuradas) ? '' : iconeNaoTemPermissao,
            permissao: Utils.getPermission(integracoes.integracoes.configuradas)
          }, {
            title: 'Consultas',
            key: 'integracoes-chamadas',
            href: '#/integracoes/chamadas',
            icon: Utils.getPermission(integracoes.integracoes.consultas) ? '' : iconeNaoTemPermissao,
            permissao: Utils.getPermission(integracoes.integracoes.consultas)
          }
        ]
      },
      {
        key: 'regras',
        title: 'Regras de usuário',
        href: { name: 'regras' },
        permissao: permissaoRegras
      },
      {
        key: 'empresas',
        title: 'Empresas',
        href: { name: 'empresas' },
        permissao: permissaoRegras // mudar
      }
    ],
    permissao: permissaoRegras // mudar
  }
];

export default menuConfig.map(menu => {
  if (menu.permissao) {
    if (menu.children) {
      return { ...menu, children: menu.children.filter(menu => menu.permissao) };
    } else {
      return menu;
    }
  }
}).filter(menu => !!menu);
